import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import MobileSubNav from "~/components/MobileSubNav";
import { NavLinkWrapper } from "~/components/Header";
import {
    MainNavWithSubNav,
    MainNavWithSubNavIcon,
} from "~/components/MainMobileNavigationItem";

import { clearAllBodyScrollLocks } from "body-scroll-lock";
import trackNavigationEvent from "../utilities/trackNavigationEvent";
import { sanitizeForId } from "~/utilities/helpers";

const MobileLanguageNav = ({
    tagRef = {},
    openedSubnavs = {},
    dispatch,
    label,
    links,
    menuOpened = false,
}) => {
    const [wasOpened, setOpened] = useState(false);
    useEffect(() => {
        if (openedSubnavs.secondary === "Language-0" && !wasOpened) {
            setOpened(true);
        }
    }, [openedSubnavs, wasOpened, setOpened]);

    useEffect(() => {
        if (wasOpened) {
            if (!menuOpened && tagRef.current) {
                tagRef.current.firstElementChild.focus();
                setOpened(false);
            }
        }
    }, [menuOpened, wasOpened, tagRef]);

    return (
        <NavLinkWrapper ref={tagRef}>
            <MainNavWithSubNav
                type="button"
                onClick={(e) => {
                    e.preventDefault();
                    trackNavigationEvent(true, 1, label, false);
                    dispatch({
                        type: "HANDLE_SUB_NAV",
                        id: `${sanitizeForId(label)}-0`,
                        currentSubNavs: openedSubnavs,
                        level: "secondary",
                    });
                }}
                bold
                aria-label={`${label} submenu`}
                id={`${sanitizeForId(label)}-0`}
                hidden={menuOpened}
            >
                {label}
                <MainNavWithSubNavIcon name="arrow-right" />
            </MainNavWithSubNav>
            <MobileSubNav
                {...{
                    clearAllBodyScrollLocks,
                    openedSubnavs,
                    dispatch,
                }}
                level="secondary"
                firstLinkLabel={label}
                parentLinkNativeName={label}
                firstLinkLabelIndex={0}
                linkLabel={label}
                isOpen={openedSubnavs.secondary === `${label}-0`}
                items={links}
            />
        </NavLinkWrapper>
    );
};

MobileLanguageNav.propTypes = {
    tagRef: PropTypes.object,
    openedSubnavs: PropTypes.shape({}),
    dispatch: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            linkLabel: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.object,
            ]),
            linkNativeName: PropTypes.string,
            linkTranslatedName: PropTypes.string,
            languageCode: PropTypes.string,
            linkUrl: PropTypes.string.isRequired,
        }),
    ).isRequired,
    menuOpened: PropTypes.bool,
};

export default MobileLanguageNav;
